import React, { useRef, useCallback, useState } from 'react';
import { STATIC_PATH_S3 } from '../../../../config';
import OwlCarousel from '../../../../components/OwlCarousel/OwlCarousel';

const tariffData = [
  {
    id: 0,
    title: 'CPA',
    description: 'Фиксированная выплата за целевое действие',
    advantages: [
      'Подходит, если вам важна простая и предсказуемая экономика. Пользователь оформляет подписку — вы получаете разовое вознаграждение за привлечённого клиента',
    ],
    policy: 'Предсказуемый доход',
    number: '1',
    icon: 'black-circle.svg',
    isGreen: true,
  },
  {
    id: 1,
    title: 'Hybrid',
    description: 'Аванс + регулярные платежи',
    advantages: [
      'Модель для тех, кто активно закупает трафик и хочет быстрее возвращать деньги в оборот.',
      'Вы получаете аванс сразу после оформления подписки, используете его для масштабирования рекламы, а первые регулярные платежи клиента постепенно закрывают сумму аванса. После этого последующие оплаты идут вам в прибыль',
    ],
    policy: 'Быстрый старт',
    number: '2',
    icon: 'black-circle2.svg',
    isGreen: false,
  },
  {
    id: 2,
    title: 'RevShare',
    description: 'Доход с регулярных оплат',
    advantages: [
      'Модель для тех, кто приводит качественную аудиторию и хочет зарабатывать на повторных платежах. Клиент продолжает пользоваться подпиской — вы продолжаете получать процент с успешных списаний.',
    ],
    policy: 'Долгий доход',
    number: '3',
    icon: 'black-circle3.svg',
    isGreen: false,
  },
];

const TariffCard = ({ data }) => (
  <div className={`tariff__item ${data.isGreen ? 'green' : ''}`}>
    <div className="tariff__item-top">
      <div className="wrapper-icon">
        <img
          src={`${STATIC_PATH_S3}main-page/${data.icon}`}
          alt={data.title}
          width="54"
          height="54"
        />
      </div>
      <h6 className="tariff__item-title">{data.title}</h6>
    </div>
    <p className="tariff__item-text">{data.description}</p>
    <ul className="tariff__item-advantages">
      {data.advantages.map((text, index) => (
        <li key={index} className="tariff__item-advantages-item">
          <p className="tariff__item-advantages-item-text">{text}</p>
        </li>
      ))}
    </ul>
    <div className="tariff__item-bottom">
      <div className="tariff__item-policy">{data.policy}</div>
      <div className="tariff__item-number">{data.number}</div>
    </div>
  </div>
);

const TariffBlock = () => {
  const carouselRef = useRef(null);
  const [isCarouselReady, setIsCarouselReady] = useState(false);

  const options = {
    items: 1,
    margin: 8,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: false,
    nav: true,
    dots: true,
    loop: false,
    responsive: {
      991: {
        items: 2,
        margin: 16,
      },
      1500: {
        items: 4,
        margin: 20,
      },
      1900: {
        items: 5,
        margin: 24,
      },
    },
  };

  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  return (
    <>
      <div className="tariff__block tariff__block--desktop">
        <ul className="tariff__list">
          {tariffData.map((item) => (
            <TariffCard key={item.id} data={item} />
          ))}
        </ul>
      </div>

      <div className="tariff__block tariff__block--mobile">
        <OwlCarousel {...options} className="owl-theme">
          {tariffData.map((item) => (
            <div className="item" key={item.id}>
              <TariffCard data={item} />
            </div>
          ))}
        </OwlCarousel>
      </div>
    </>
  );
};

export default TariffBlock;
